import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { format } from "date-fns";
import { ar } from "date-fns/locale";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ScrollText } from "lucide-react";
import { CUNEIFORM_TEXTURE } from "@/lib/brand";

const EASE = [0.16, 1, 0.3, 1];

export default function Bylaws() {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    api("/bylaws").then(setDoc).catch((e) => toast.error(e.message));
  }, []);

  return (
    <div data-testid="bylaws-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: EASE }}>
        <h1 className="mb-2 flex items-center gap-3 font-amiri text-4xl text-navy sm:text-5xl">
          <ScrollText className="h-8 w-8 text-gold-dark" />
          النظام الداخلي
        </h1>
        <p className="mb-8 text-muted-foreground">دستور اتحاد نابو — المواد والأحكام التي تنظم عملنا.</p>
      </motion.div>

      {doc === null ? (
        <p className="py-16 text-center text-muted-foreground">جارٍ التحميل...</p>
      ) : (
        <motion.article
          className="relative overflow-hidden rounded-2xl border border-gold/30 bg-white shadow-sm"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: EASE }}
          data-testid="bylaws-document"
        >
          <div aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.05] mix-blend-multiply">
            <img src={CUNEIFORM_TEXTURE} alt="" className="h-full w-full object-cover" />
          </div>
          <div className="relative border-b border-gold/25 px-6 py-10 text-center sm:px-12">
            <img src="/favicon.svg" alt="" className="mx-auto mb-6 h-14 w-14 rounded-xl" />
            <h2 className="font-amiri text-3xl font-bold text-gold-gradient sm:text-4xl" data-testid="bylaws-title">
              {doc.title}
            </h2>
            {doc.updated_at && (
              <p className="mt-4 text-xs text-muted-foreground">
                آخر تحديث: {format(new Date(doc.updated_at), "d MMMM yyyy", { locale: ar })}
                {doc.updated_by ? ` — بواسطة ${doc.updated_by}` : ""}
              </p>
            )}
          </div>
          <div
            className="relative whitespace-pre-wrap px-6 py-10 font-amiri text-lg leading-[2.2] text-navy/90 sm:px-12 sm:text-xl"
            data-testid="bylaws-content"
          >
            {doc.content}
          </div>
        </motion.article>
      )}
    </div>
  );
}
